<template>
  <el-dialog
    title="Iniciar Desocupação"
    :visible.sync="visibility"
    :before-close="fechar"
    :close-on-click-modal="false"
    :modal-append-to-body="false"
    @open="reset"
    width="35%"
  >
    <el-form ref="form" :rules="validacao" :model="desocupacao" size="small" label-position="top" hide-required-asterisk :show-message="false">
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="Aviso de Desocupação" prop="dataAvisoDesocupacao">
            <el-date-picker
              v-model="desocupacao.dataAvisoDesocupacao"
              v-mask="'##/##/####'"
              type="date"
              format="dd/MM/yyyy"
              value-format="dd/MM/yyyy"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Previsão de Desocupação" prop="dataPrevisaoDesocupacao">
            <el-date-picker
              v-model="desocupacao.dataPrevisaoDesocupacao"
              v-mask="'##/##/####'"
              type="date"
              format="dd/MM/yyyy"
              value-format="dd/MM/yyyy"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="desocuparAluguelHandler()" type="primary" size="small" round class="btn-box-shadow">Concluir</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Util from "../../../util/funcoes.js";

export default {
  props: {
    visibility: Boolean,
    tipo: String
  },
  data() {
    return {
      desocupacao:{
        dataAvisoDesocupacao: Util.hoje(),
        dataPrevisaoDesocupacao: undefined
      },

      validacao:{
        dataAvisoDesocupacao: [{ required: true, len: 10 }],
        dataPrevisaoDesocupacao: [{ required: true, len: 10 }]
      }
    };
  },
  computed: {
    ...mapState("alugueisContratosStore", {
      aluguel(state) { return state.aluguelSelecionado; }
    })
  },
  methods: {
    ...mapActions(["showLoading", "hideLoading"]),
    ...mapActions("alugueisContratosStore", ["desocuparAluguel"]),

    desocuparAluguelHandler() {
      this.$refs["form"].validate(valid => {
        if(valid) {
          this.desocupar();
        } else {
          this.exibirAlert("Atenção", "Preencha todos os campos obrigatórios");
        }
      });
    },

    desocupar() {
      this.showLoading();
      this.desocupacao = { ...this.desocupacao, id: this.aluguel.id,}
      this.desocuparAluguel(this.desocupacao)
      .then(resultado => {
        this.hideLoading();
        switch (resultado.status) {
        case "SUCESSO":
          this.$message.success(resultado.mensagem);
          this.concluir();
          break;
        case "FALHA":
        case "ERRO":
          this.$message.error(resultado.mensagem);
        }
      }).catch(() => {
        this.$message.error("Ocorreu um erro.");
        this.hideLoading();
      });
    },

    reset() {
      this.desocupacao = {
        dataAvisoDesocupacao: Util.hoje(),
        dataPrevisaoDesocupacao: undefined
      }
    },

    fechar() {
      this.$emit("close");
    },

    concluir() {
      this.$emit('desocupar');
    },
  }
};
</script>

